var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.banner)?_c('Banner',{attrs:{"banner":_vm.banner}}):_vm._e(),_vm._l((_vm.pages),function(page){return _c('div',{key:page.id,staticClass:"container pages pt-4 pb-4"},[_c('div',{staticClass:"mt-4 mb-4",domProps:{"innerHTML":_vm._s(page.page_data['gjs-html'])}})])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }